import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import {
  getMyProfile,
  getUserNotificationSettings,
  getUserPreferences,
  setMyProfile,
  setNotificationSettings,
  updateNotificationSettings,
  updateProfileForm,
  updateProfileFormFailed,
  updateProfileFormSuccess,
  updateUserPreferences,
  updateUserPreferencesFailed,
  updateUserPreferencesSuccess,
} from './slice';
import * as endpoints from './endpoints';
import { loginSuccess } from '../auth/slice';

function* updateProfileFormSaga({ payload }: ReturnType<typeof updateProfileForm>): any {
  try {
    const { name, id } = payload;
    const response = yield call(request.put, `${endpoints.updateUser}/${id}`, {
      name,
      profilePhoto: '',
    });

    yield put(updateProfileFormSuccess(response.data));
    yield put(loginSuccess(response.data));
  } catch (error: any) {
    yield put(updateProfileFormFailed(error));
  }
}

function* getUserNotificationSettingsSaga({
  payload,
}: ReturnType<typeof getUserNotificationSettings>): any {
  try {
    const { userId } = payload;
    const response = yield call(request.get, `${endpoints.getUserNotificationSetting}/${userId}`);
    yield put(setNotificationSettings(response.notificationsSettings));
  } catch (error: any) {
    // showMessage({message: error.message, type: 'danger'});
  }
}

function* updateNotificationSettingsSaga({
  payload,
}: ReturnType<typeof updateNotificationSettings>): any {
  try {
    const { promotionalEmails, notificationsForMeal, userId } = payload;
    const response = yield call(
      request.patch,
      `${endpoints.updateUserNotificationSetting}/${userId}`,
      {
        promotionalEmails,
        notificationsForMeal,
      }
    );
    yield put(setNotificationSettings(response.data));
    // showMessage({message: response.message, type: 'success'});
  } catch (error: any) {
    // showMessage({message: error.message, type: 'danger'});
  }
}

function* getUserPreferencesSaga({ payload }: ReturnType<typeof getUserPreferences>): any {
  try {
    const { userId } = payload;
    const response = yield call(request.get, `${endpoints.getUserPreferences}/${userId}`);

    if (response.data) {
      yield put(updateUserPreferencesSuccess(response.data));
    }
  } catch (error: any) {
    yield put(updateUserPreferencesFailed(error));
  }
}

function* updateUserPreferencesSaga({ payload }: ReturnType<typeof updateUserPreferences>): any {
  try {
    // yield put(loader.present(updateUserPreferences.type, {global: false}));

    const response = yield call(request.post, endpoints.updateUserPreferences, {
      ...payload,
    });

    if (response.data) {
      yield put(updateUserPreferencesSuccess(response.data));
    }
  } catch (error: any) {
    yield put(updateUserPreferencesFailed(error));
  }
}

function* getMyProfileSaga({}: ReturnType<typeof getMyProfile>): any {
  try {
    const response = yield call(request.get, endpoints.getMyProfile);

    yield put(setMyProfile(response.data));
  } catch (error: any) {
    // showMessage({message: error.message, type: 'danger'});
  }
}

function* manageProfileSagas() {
  yield all([takeLatest(updateProfileForm, updateProfileFormSaga)]);
  yield all([takeLatest(getUserNotificationSettings, getUserNotificationSettingsSaga)]);
  yield all([takeLatest(updateNotificationSettings, updateNotificationSettingsSaga)]);
  yield all([takeLatest(getUserPreferences, getUserPreferencesSaga)]);
  yield all([takeLatest(updateUserPreferences, updateUserPreferencesSaga)]);
  yield all([takeLatest(getMyProfile, getMyProfileSaga)]);
}
export { manageProfileSagas };
